<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <line x1="1" x2="23" y1="1" y2="23"></line>
    <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path>
    <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path>
    <path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path>
    <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path>
    <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
    <path d="M12.63,20.63L12.64,20.63"/>
  </svg>
</template>

<script>
export default {
  name: 'NoWifiIcon',
};
</script>

<style scoped lang="scss">
line {
  stroke: var(--colors-main-font);
}

path {
  fill: none;
  stroke: var(--colors-main-font);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}
</style>
